import * as React from 'react'
import { FC } from 'react'
import Tooltip from '@mui/material/Tooltip'

interface Props {
  label: string
  expanded: boolean
  children: React.ReactElement
}

/**
 * Tooltip for a side-nav row, shared by the Sales Center links and the buttons
 * below them.
 *
 * Collapsed, the drawer is 47px wide and the label is clipped, so the tooltip
 * is the only thing naming the icon. Expanded, the label is already visible,
 * so the triggers are switched off rather than blanking the title — Tooltip
 * mirrors the title into aria-label, and an empty one would leave the
 * accessible name resting on the accname spec's empty-label fallthrough
 * instead of stating it outright.
 */
export const NavTooltip: FC<Props> = ({ label, expanded, children }) => (
  <Tooltip
    title={label}
    placement="right"
    disableHoverListener={expanded}
    disableFocusListener={expanded}
    disableTouchListener={expanded}
  >
    {children}
  </Tooltip>
)
NavTooltip.displayName = 'NavTooltip'
